import { generalTaskPriorityOptions } from "@roc/feature-general-tasks";
import { SelectField } from "@roc/ui";
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  selectField: {
    '& .MuiOutlinedInput-input': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      width: '280px',
    },
  },
}));

const ALL = 'ALL';
const ALL_OPTION = { label: 'All', value: ALL };

const removePlaceholder = opts => opts.filter(o => o !== ALL);
const isAllSelected = (currentOptions, selectedOptions) =>
  currentOptions.length > 0 && selectedOptions.some(o => o === ALL);

export const PriorityFilterField = ({ value, onChange }) => {
  const classes = useStyles();
  const currentOptions = value ?? [];
  const isEmpty = currentOptions.length === 0;

  return (
    <SelectField
      testId={'priority'}
      label={'Priority'}
      value={isEmpty ? [ALL] : value}
      onChange={(selectedOptions) => {
        const shouldClear = isAllSelected(currentOptions, selectedOptions);
        onChange(shouldClear ? [] : removePlaceholder(selectedOptions));
      }}
      options={[ALL_OPTION].concat(generalTaskPriorityOptions)}
      className={classes.selectField}
      variant="outlined"
      fullWidth
      shrink
      multiple
    />
  );
};